import React from 'react';
import { IRootState, Dispatch } from '../../redux/store/configureStore';
import { Card } from 'components';
import { connect } from 'react-redux';
import { IChangePassword } from '../../api/ApiClient';
import ProfileInfoBlock from 'components/ProfileInfoBlock/ProfileInfoBlock';
import styles from './ProfileContainer.module.scss';

const ProfileContainer = ({
    auth, apiError, changePassword,
}: Props) => {
    const changePass = async (data: IChangePass) => {
        let res: boolean | null = false;
        if (data.oldPassword) {
            const nData = data as IChangePassword;
            res = await changePassword(nData);
        }

        return res;
    };

    return (
        <Card
          borderedTitle
          title={`${auth && auth.profile.lastName} ${auth && auth.profile.firstName} `}
          contentClassName={styles.profile__container}
          apiError={apiError}
          showLoader={!auth || !auth.profile}
        >
            {auth && (
                <ProfileInfoBlock
                  profile={auth.profile}
                  apiError={apiError}
                  onChangePassword={changePass}
                  withoutBirthDate
                  withoutSex
                  hideChangeButtons
                  disabled
                />
            )}
        </Card>
    );
};

const mapState = (state: IRootState) => ({
    auth: state.auth,
    apiError: state.errors.error,
});

const mapDispatch = (dispatch: Dispatch) => ({
    changePassword: dispatch.auth.changePasswordAsync,
});

export default connect(mapState, mapDispatch)(ProfileContainer);

type connectedProps = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch>;
type Props = connectedProps;

interface IChangePass {
    newPassword: string;
    oldPassword?: string;
    captcha?: string;
}
